const locationsHolder = document.querySelectorAll(".locations-holder, .mod-directory:has(.directory-filter)");

locationsHolder.forEach((holder) => {
    const filterButtons: NodeListOf<HTMLButtonElement> =
        holder.querySelectorAll(".filter button");
    const locations: NodeListOf<HTMLDivElement> =
        holder.querySelectorAll(".location-card, .directory-card");

    if (locations) {
        filterButtons.forEach((button) => {
            button.addEventListener("click", (btn) => {
                const fizzBuzz = btn.target as HTMLButtonElement;
                filterButtons.forEach((x) => {
                    if (x == fizzBuzz) {
                        x.classList.add("active");
                    } else {
                        x.classList.remove("active");
                    }
                });
                locations[0].parentElement.classList.add("fadeout");

                setTimeout(() => {
                    locations.forEach((loc) => {
                        loc.dataset.visible = "";
                        const fizzFeature = (
                            fizzBuzz.dataset.feature || ""
                        ).trim();
                        if (fizzFeature) {
                            const locFeatures = (loc.dataset.features || "")
                                .split("|")
                                .map((s) => s.trim());

                            if (locFeatures.includes(fizzFeature) || fizzFeature == "" || fizzFeature == "🔥" || fizzFeature == 'all') {
                                loc.dataset.visible = "1";
                            }
                        }
                    });
                    locations[0].parentElement.classList.remove("fadeout");
                }, 300);
            });
        });
    }
});
